module.exports = __webpack_public_path__ + "img/fifth1.e47d74a4.png";